// internal
import { axios, def, handleError, handleResponse } from './internal';

// client-shared
import { array } from '@goldblack/client-utils';

function AdminUserSearch(service, filters, skip, limit, setData) {
    setData((prev) => ({ ...prev, loading: true }));
    const requestSkip = skip;

    axios
        .post('/api/admin_user_search', {
            service,
            filters,
            skip,
            limit,
        })
        .then((res) => {
            setData((prev) => ({ ...prev, loading: false }));

            switch (res.data.code) {
                case def.ErrorCode.OK:
                    const { users, skip: nextSkip } = res.data.data;
                    setData((prev) => ({
                        skip: nextSkip,
                        loadmore: users.length === limit,
                        data: requestSkip === 0 ? users : array.concatArray(prev.data, users),
                    }));
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            setData((prev) => ({ ...prev, loading: false }));
            handleError(err);
        });
}

export { AdminUserSearch };
